import { render, staticRenderFns } from "./CountryBadge.vue?vue&type=template&id=82b4647a&scoped=true"
import script from "./CountryBadge.vue?vue&type=script&lang=js"
export * from "./CountryBadge.vue?vue&type=script&lang=js"
import style0 from "./CountryBadge.vue?vue&type=style&index=0&id=82b4647a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b4647a",
  null
  
)

export default component.exports